import React from 'react'

export default function Extras() {
  return (
    <div>Extras</div>
  )
}
